<h2 mat-dialog-title>Add Resources</h2>
<button mat-icon-button class="close-button" (click)="cancel()">
  <mat-icon>close</mat-icon>
</button>

<mat-dialog-content align="center">
  <h4>
    Do you want to use resources from another model?
  </h4>
</mat-dialog-content>

<mat-dialog-actions align="center">
    <button type="button" class="discard-button" (click)="onNo()">
    <mat-icon>close</mat-icon>
    NO
  </button>
  <button type="button" class="confirm-button" (click)="onYes()">
    <mat-icon>check</mat-icon>
    YES
  </button>
</mat-dialog-actions>
